// Re-export commonly used constants (single export to avoid duplicate named exports)
export { 
  API_CONFIG,
  SUCCESS_CODES,
  ERROR_CODES,
  PERMISSION_BITS,
  ACCOUNT_STATUS,
  PAGINATION_DEFAULTS,
  DATE_FORMATS,
  SECURITY_HEADERS,
  STORAGE_KEYS,
  CONTROLLERS,
  ACTIONS,
  ERROR_MESSAGES,
  SUCCESS_MESSAGES,
  APP_VERSION
} from './api'; 
// eslint-disable-next-line no-useless-escape
export const PASSWORD_REGEX = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{6,}$/;
export const PASSWORD_MSG = 'Mật khẩu phải >= 6 ký tự, bao gồm chữ, số và ký tự đặc biệt';